// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__dbatI","extendedLabel":"Switch_extendedLabel__2Fndr"};